export default __webpack_public_path__ + "static/media/ostra.ed58776e.png";